import type { DialogOptions, DialogService } from '@patsnap/tahiti-core';
import type { Glossary } from './glossary-service';

export const RequestGlossaryService = Symbol('RequestGlossaryService');

/**
 * 获取反馈的服务
 * @description 用于获取反馈内容
 */
export interface RequestGlossaryService extends DialogService<DialogOptions, Glossary> {
    /**
     * @description 打开术语表
     * @returns 返回术语表
     */
    open(): Promise<Glossary>;
}

